export default __webpack_public_path__ + "static/media/ReminderWithNoNotification.db29f07c.svg";